































































































































































































































































































































































































import { Patient, PatientInfo, PatientsRecord } from "@/types";
import { MEASUREMENT_STATUS, MEASUREMENT_COLORS } from "@/utils/store-util";
import { Component, Watch } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import {extractInfo, formatValue} from "@/utils/app-util";
import { getDefaultPagination, getPagination } from "@/utils/store-util";
import http from "@/http/axios";
import {} from "../types";
Vue.use(VueApexCharts);
@Component({
  components: {
    VueApexCharts,
  },
})
export default class Dashboard extends Vue {
  public loading = false;
  public timer = null;
  public patients: Patient[] = [];
  public patients_record: PatientsRecord[] = [];
  public chart_loading = false;
  public switch1 = true;
  public totalPatients = 0;
  public items: PatientInfo[] = [];
  public pagination = getDefaultPagination();
  public totalPages = 0;
  public currentPage = 1;
  public optionlimit = 10;
  public switchMask = true;
  private patientOptions = {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
  };
  private lastSearch = "";
  public DropdownPlace = [];
  public place = {
    branch_name: [],
    index: [],
    shortcode: [],
  };

  public s_chartOptions = [];
  public s_series = [];
  public s_rule = {
    warning: [],
    bad: [],
  };
  public d_rule = {
    warning: [],
    bad: [],
  };

  public p_chartOptions = [];
  public p_series = [];
  public p_rule = {
    warning: [],
    bad: [],
  };

  // public b_chartOptions = [];
  // public b_series = [];
  // public b_rule = {
  //   warning: [],
  //   bad: [],
  // };
  @Watch("DropdownPlace",{immediate:false, deep:true})
  Dropdown(){
    //console.log(this.DropdownPlace);
    this.patientOptions.page = 1;
    if (this.DropdownPlace.length!==0){
      this.updateCard();
    }else{
      this.clearPatient();
    }
  }
  @Watch("optionlimit",{immediate:false, deep:true})
  changelimit(){
    this.patientOptions.page = 1;
    if (this.DropdownPlace.length!==0){
      this.updateCard();
    }else{
      this.clearPatient();
    }
  }

  @Watch("loading", { immediate: true, deep: true })
  updateData() {
    this.chart_loading = true;
  }
  @Watch("switch1", {immediate: false,deep: true})
  handleswitch(){
    if(this.switch1){
      
      //this.updateCard();
      
     
      this.timer = setInterval(()=>{
        this.updateCard();
    }, 1000 * 60 * 5); //每5分鐘更新一次
    }else{
      clearInterval(this.timer);
    }
  }
  async created() {
    // 移到 hadleswitch 做
    this.setPagination(getDefaultPagination());
    await this.getPlaceList();
    await this.getMeasurementTypes();
    // await this.updateCard();
  }

  async updateCard() {
    await this.allPatients();
    await this.updateChart();
  }
  async beforeDestroy() { 
    clearInterval(this.timer);
  } 
  async destroyed() {
    this.clearPatient();
  }
  // 取得所有病人量測資料
  async allPatients() {
    this.loading = true;
    await this.clearPatient();
    if (!this.loading) {
      if (this.patientOptions.q !== this.lastSearch) {
        this.patientOptions.page = 1;
        this.lastSearch = this.patientOptions.q;
      }
    }
    let request_path = "";
    if(this.DropdownPlace.length === 0 || this.DropdownPlace === undefined){
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=${this.optionlimit}&sort=measure,desc,BLOOD_PRESSURE&record=mode%3Afull%7Cfield%3Aall&role=Patient`
    }else{
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=${this.optionlimit}&sort=measure,desc,BLOOD_PRESSURE&record=mode%3Afull%7Cfield%3Aall&role=Patient&place=name%3A${this.DropdownPlace.join()}`
    }
    const result = await http.get(
      request_path
    );
    if (result) {
      const data = result.data.data;
      this.totalPatients = data.total_users;
      this.totalPages = data.total_page;
      this.currentPage = this.patientOptions.page;
      // Extract Table Data
      this.patients_record = await this.extractPatientInfo(data.users);
      const pagination = getPagination(
        this.items,
        this.totalPages,
        this.currentPage
      );
      this.setPagination(pagination);
    } else {
      console.error(result);
    }
  }
  maskname(name){
    const len = name.length;
    switch (len) {
      case 2:
        name = name.substring(0, 1) + "◯";
        break;
      case 3:
        name =
          name.substring(0, 1) +
          "◯" +
          name.substring(2, 3);
        break;
      case 4:
        name =
          name.substring(0, 1) +
          "◯◯" +
          name.substring(3, 4);
        break;
      default:
        name =
          name.substr(0, 3) +
          "◯".repeat(len - 6 > 0 ? len - 6 : 1) +
          name.substr(len - 3, 3);
        break;
      }
    return name;
  }

  async extractPatientInfo(patients) {
    const patients_record = [];
    const today_timestamp = new Date(Date.now()).getTime()/1000;
    // const re = /^[0-9][a-zA-Z]/;
    for (const patient of patients) {
      if (patient.user) {
        // const len = patient.user.name.length;
        // if(patient.user.name.substring(0,2)==='民眾'){
        //   patient.user.name = patient.user.name.substring(0,3) + this.maskname(patient.user.name.substring(3));
        // }
        // else if(patient.user.name.substring(0,2)==='院內'){
        //   patient.user.name = patient.user.name.substring(0,5) + this.maskname(patient.user.name.substring(5));
        // }
        // else if(!re.test(patient.user.name) || len >= 10){
        //   patient.user.name = this.maskname(patient.user.name);
        // }
        patient.user.place = this.codetoPlace(patient.user);
        patient.user = await extractInfo(patient.user);

        if (patient.record.blood_pressure.systolic.measure_at !== null) {
          // move to backend ?
          if(today_timestamp - patient.record.blood_pressure.systolic.measure_at > 86400*3){
            patient.record.blood_pressure.systolic['freq_warning'] = true;
          }else{
            patient.record.blood_pressure.systolic['freq_warning'] = false;
          }
          patient.record.blood_pressure.systolic.measure_at = new Date(
            patient.record.blood_pressure.systolic.measure_at * 1000
          ).toLocaleString();
          patient.record.blood_pressure.systolic.value = Number.parseFloat(
            patient.record.blood_pressure.systolic.value
          ).toFixed(0);
          patient.record.blood_pressure.diastolic.value = Number.parseFloat(
            patient.record.blood_pressure.diastolic.value
          ).toFixed(0);
        }
        if (patient.record.blood_pressure.pulse.measure_at !== null) {
          if(today_timestamp - patient.record.blood_pressure.pulse.measure_at > 86400*3){
            patient.record.blood_pressure.pulse['freq_warning'] = true;
          }else{
            patient.record.blood_pressure.pulse['freq_warning'] = false;
          }
          patient.record.blood_pressure.pulse.measure_at = new Date(
            patient.record.blood_pressure.pulse.measure_at * 1000
          ).toLocaleString();
          patient.record.blood_pressure.pulse.value = Number.parseFloat(
            patient.record.blood_pressure.pulse.value
          ).toFixed(0);
        }
        if (patient.record.blood_glucose.blood_glucose.measure_at !== null) {
          patient.record.blood_glucose.blood_glucose.measure_at = new Date(
            patient.record.blood_glucose.blood_glucose.measure_at * 1000
          ).toLocaleString();
          patient.record.blood_glucose.blood_glucose.value = Number.parseFloat(
            patient.record.blood_glucose.blood_glucose.value
          ).toFixed(0);
        }
        if (patient.record.frailty.sarcopenia.measure_at !== null){
          if(today_timestamp - patient.record.frailty.sarcopenia.measure_at > 86400*30){
            patient.record.frailty.sarcopenia['freq_warning'] = true;
          }else{
            patient.record.frailty.sarcopenia['freq_warning'] = false;
          }
          patient.record.frailty.sarcopenia.measure_at = new Date(
            patient.record.frailty.sarcopenia.measure_at * 1000
          ).toLocaleString();
          patient.record.frailty.sarcopenia.value = formatValue(
            patient.record.frailty.sarcopenia.value
          );
        }
        patients_record.push({
          user: patient,
          record: await this.patientRecord(patient),
        });
      }
    }
    return patients_record;
  }

  setPagination(pagination) {
    this.pagination = pagination;
  }

  async getPlaceList() {
    const result = await http.get(`/place`);
    if (result) {
      for (let i = 0; i < result.data.data.place.length; i++) {
        this.place.branch_name.push(result.data.data.place[i].branch_name);
        this.place.index.push(result.data.data.place[i].index);
        this.place.shortcode.push(result.data.data.place[i].shortcode);
      }
    } else {
      console.error(result.data.status);
    }
  }

  codetoPlace(item) {
    if (item.place !== null) {
      const pCode = item.place.split(",");
      for (let i = 0; i < this.place.branch_name.length; i++) {
        if (this.place.shortcode[i] == pCode[0]) {
          if (this.place.index[i] == pCode[1]) {
            return this.place.branch_name[i];
          }
        }
      }
    } else return;
  }

  async getMeasurementTypes(): Promise<TODO> {
    const result = await http.get(`/measurements/types`);
    if (result) {
      const data = result.data.data.measurement_type;
      this.s_rule = this.updateRule(data.systolic.rule);
      this.d_rule = this.updateRule(data.diastolic.rule);
      this.p_rule = this.updateRule(data.pulse.rule);
      // console.log(this.s_rule);
      // console.log(this.d_rule);
      // 血糖先不用
      // this.b_rule = this.updateRule(data.blood_glucose.rule);
    } else {
      console.error(result);
    }
    return result;
  }

  async patientRecord(user: Patient) {
    this.loading = true;
    const result = await http.get(
      `/user/${user.user.uuid}/record?only=blood_pressure:all&limit=-1&range=21,d`
    );
    const record = {
      systolic: [],
      diastolic: [],
      pulse: [],
      blood_glucose: [],
    };

    if (result.data.data) {
      const data = result.data.data;
      for (const i in data.records) {
        if (data.records[i].key === "systolic") {
          const date = new Date(
            data.records[i].measure_at * 1000
          ).toLocaleString();
          data.records[i].measure_at = date.substring(5, date.length - 3);
          record.systolic.push({
            measure_at: data.records[i].measure_at,
            value: Number.parseFloat(data.records[i].value).toFixed(2),
          });
        } else if (data.records[i].key === "diastolic") {
          const date = new Date(
            data.records[i].measure_at * 1000
          ).toLocaleString();
          data.records[i].measure_at = date.substring(5, date.length - 3);
          record.diastolic.push({
            measure_at: data.records[i].measure_at,
            value: Number.parseFloat(data.records[i].value).toFixed(2),
          });
        } else if (data.records[i].key === "pulse") {
          const date = new Date(
            data.records[i].measure_at * 1000
          ).toLocaleString();
          data.records[i].measure_at = date.substring(5, date.length - 3);
          record.pulse.push({
            measure_at: data.records[i].measure_at,
            value: Number.parseFloat(data.records[i].value).toFixed(2),
          });
        } else if (data.records[i].key === "blood_glucose") {
          const date = new Date(
            data.records[i].measure_at * 1000
          ).toLocaleString();
          data.records[i].measure_at = date.substring(5, date.length - 3);
          record.blood_glucose.push({
            measure_at: data.records[i].measure_at,
            value: Number.parseFloat(data.records[i].value).toFixed(2),
          });
        }
      }
      return record;
    } else {
      console.error(result);
    }
  }

  updateRule(rule) {
    const value = {
      warning: [],
      bad: [],
    };

    for (const i in rule) {
      if (rule[i].result === MEASUREMENT_STATUS.WARNING) {
        value.warning.push(rule[i].value);
      } else if (rule[i].result === MEASUREMENT_STATUS.BAD) {
        value.bad.push(rule[i].value);
      }
    }

    return value;
  }

  updateChart() {
    const s_value = [];
    const s_measure_at = [];
    const d_value = [];
    const d_measure_at = [];
    const p_value = [];
    const p_measure_at = [];
    // const b_value = [];
    // const b_measure_at = [];
    // const s_warning = [];
    // const s_bad = [];
    // const d_warning = [];
    // const d_bad = [];
    // const p_warning = [];
    // const p_bad = [];
    // const b_warning = [];
    // const b_bad = [];
    // const b_low_bad = [];
    for (const i in this.patients_record) {
      s_value[i] = [];
      s_measure_at[i] = [];
      d_value[i] = [];
      d_measure_at[i] = [];
      p_value[i] = [];
      p_measure_at[i] = [];
      // b_value[i] = [];
      // b_measure_at[i] = [];
      // s_warning[i] = [];
      // s_bad[i] = [];
      // d_warning[i] = [];
      // d_bad[i] = [];
      // p_warning[i] = [];
      // p_bad[i] = [];
      // b_warning[i] = [];
      // b_bad[i] = [];
      // b_low_bad[i] = [];
      if (this.patients_record[i].record) {
        for (const j in this.patients_record[i].record.systolic) {
          s_value[i][j] = this.patients_record[i].record.systolic[j].value;
          s_measure_at[i][j] = this.patients_record[i].record.systolic[
            j
          ].measure_at;
          // s_warning[i][j] = this.s_rule.warning[0];
          // s_bad[i][j] = this.s_rule.bad[0];
        }
        for (const j in this.patients_record[i].record.diastolic) {
          d_value[i][j] = this.patients_record[i].record.diastolic[j].value;
          d_measure_at[i][j] = this.patients_record[i].record.diastolic[
            j
          ].measure_at;
          // d_warning[i][j] = this.d_rule.warning[0];
          // d_bad[i][j] = this.d_rule.bad[0];
        }
        for (const j in this.patients_record[i].record.pulse) {
          p_value[i][j] = this.patients_record[i].record.pulse[j].value;
          p_measure_at[i][j] = this.patients_record[i].record.pulse[
            j
          ].measure_at;
          // p_warning[i][j] = this.p_rule.warning[0];
          // p_bad[i][j] = this.p_rule.bad[0];
        }
        // 血糖先不用
        // for (const j in this.patients_record[i].record.blood_glucose) {
        //   b_value[i][j] = this.patients_record[i].record.blood_glucose[j].value;
        //   b_measure_at[i][j] = this.patients_record[i].record.blood_glucose[
        //     j
        //   ].measure_at;
        //   b_warning[i][j] = this.b_rule.warning[0];
        //   b_bad[i][j] = this.b_rule.bad[0];
        //   b_low_bad[i][j] = this.b_rule.bad[1];
        // }
        this.s_series[i] = [
          {
            name: "收縮壓測量值",
            data: s_value[i],
          },
          {
            name: "舒張壓測量值",
            data: d_value[i],
          },
        ];
        this.p_series[i] = [
          {
            name: "測量值",
            data: p_value[i],
          },
        ];
        // 血糖先不用
        // this.b_series[i] = [
        //   {
        //     name: "測量值",
        //     data: b_value[i],
        //   },
        //   {
        //     name: "警告值",
        //     data: b_warning[i],
        //   },
        //   {
        //     name: "異常上限值",
        //     data: b_bad[i],
        //   },
        //   {
        //     name: "異常下限值",
        //     data: b_low_bad[i],
        //   },
        // ];

        this.s_chartOptions[i] = {
          title: {
            text: "收縮壓及舒張壓",
            align: "left",
          },
          chart: {
            type: "line",
            width: "100%",
            zoom: {
              enabled: false,
            },
          },
          xaxis: {
            categories: s_measure_at[i],
          },
          yaxis: {
            labels: {
              minWidth: 10,
            },
            max:(max)=>{
              if(!Number.isFinite(max)) return null;
              else if(max < this.s_rule.bad[0]) return this.s_rule.bad[0];
              else return max;
            },
            min:(min)=>{
              if(!Number.isFinite(min)) return null;
              else if(min > this.d_rule.warning[0]) return this.d_rule.warning[0];
              else return min;
            }
          },

          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: [3, 3],
            curve: "straight",
            dashArray: [0, 0],
          },
          markers: {
            size: [1, 1],
            hover:{
              sizeOffset: 10
            }
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          colors: ["#757575", "#757575"],
          tooltip: {
            enabledOnSeries: [0,1],
          },
          legend:{
            show: false
          },
          annotations: {
            yaxis: [
              {
                y: this.s_rule.warning[0],
                borderColor: MEASUREMENT_COLORS[1],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[1],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[1]
                  },
                }
              },
              {
                y: this.d_rule.warning[0],
                borderColor: MEASUREMENT_COLORS[1],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[1],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[1]
                  },
                }
              },
              {
                y: this.s_rule.bad[0],
                borderColor: MEASUREMENT_COLORS[2],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[2],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[2]
                  },
                }
              },
              {
                y: this.d_rule.bad[0],
                borderColor: MEASUREMENT_COLORS[2],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[2],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[2]
                  },
                }
              },
            ]
          }
        };

        this.p_chartOptions[i] = {
          title: {
            text: "脈搏",
            align: "left",
          },
          chart: {
            type: "line",
            width: "100%",
            zoom: {
              enabled: false,
            },
          },
          xaxis: {
            categories: p_measure_at[i],
          },
          yaxis: {
            labels: {
              minWidth: 10,
            },
            max:(max)=>{
              if(!Number.isFinite(max)) return null;
              else if(max < this.p_rule.bad[0]) return this.p_rule.bad[0];
              else return max;
            },
            min:(min)=>{
              if(!Number.isFinite(min)) return null;
              else if(min > this.p_rule.bad[1]) return this.p_rule.bad[1];
              else return min;
            }
          },
          zoom: {
            enabled: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: [3],
            curve: "straight",
            dashArray: [0],
          },
          markers: {
            size: [1],
            hover: {
              sizeOffset: 10,
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          colors: ["#757575"],
          tooltip: {
            enabledOnSeries: [0],
          },
          legend:{
            show: false
          },
          annotations: {
            yaxis: [
              {
                y: this.p_rule.warning[0],
                borderColor: MEASUREMENT_COLORS[1],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[1],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[1]
                  },
                }
              },
              {
                y: this.p_rule.warning[1],
                borderColor: MEASUREMENT_COLORS[1],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[1],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[1]
                  },
                }
              },
              {
                y: this.p_rule.bad[0],
                borderColor: MEASUREMENT_COLORS[2],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[2],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[2]
                  },
                }
              },
              {
                y: this.p_rule.bad[1],
                borderColor: MEASUREMENT_COLORS[2],
                strokeDashArray: 3,
                label: {
                  borderColor: MEASUREMENT_COLORS[2],
                  style: {
                    color: '#fff',
                    background: MEASUREMENT_COLORS[2]
                  },
                }
              },
            ]
          }
        };
        // 血糖先不用
        // this.b_chartOptions[i] = {
        //   title: {
        //     text: "血糖",
        //     align: "left",
        //   },
        //   chart: {
        //     type: "line",
        //     width: "100%",
        //     zoom: {
        //       enabled: false,
        //     },
        //   },
        //   xaxis: {
        //     categories: b_measure_at[i],
        //   },
        //   yaxis: {
        //     labels: {
        //       minWidth: 10,
        //     },
        //   },
        //   zoom: {
        //     enabled: false,
        //   },
        //   dataLabels: {
        //     enabled: false,
        //   },
        //   stroke: {
        //     width: [3, 3, 3, 3],
        //     curve: "straight",
        //     dashArray: [0, 3, 3, 3],
        //   },
        //   markers: {
        //     size: [6, 0, 0, 0],
        //     hover: {
        //       sizeOffset: 10,
        //     },
        //   },
        //   grid: {
        //     borderColor: "#f1f1f1",
        //   },
        //   colors: [
        //     "#757575",
        //     MEASUREMENT_COLORS[1],
        //     MEASUREMENT_COLORS[2],
        //     MEASUREMENT_COLORS[2],
        //   ],
        //   tooltip: {
        //     enabledOnSeries: [0],
        //   },
        // };
      }
    }
    this.loading = false;
  }

  updateSeries(value) {
    const Series = [
      {
        name: "測量值",
        data: value,
      },
      {
        name: "警告值",
        data: [],
      },
      {
        name: "異常值",
        data: [],
      },
    ];
    return Series;
  }

  clearPatient() {
    this.patients = [];
    this.patients_record = [];
    this.items = [];
    this.totalPages = 0;
    this.totalPatients = 0;
    this.pagination = getDefaultPagination();
    this.s_chartOptions = [];
    this.s_series = [];
    this.p_chartOptions = [];
    this.p_series = [];
    // 血糖先不用
    // this.b_chartOptions = [];
    // this.b_series = [];
  }
}
